import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { IcepanelComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanel.component';
import { IcepanelContainerComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanelcontainer.component';
import { IcecontrolSettings } from '../../../../icemedx-lib/src/components/models/icesettings';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { medicalservice } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservice';
import { orderentryindex } from '../../../../icemedx-lib/src/models/ehr/orderentryindex';
import { managementguideline } from '../../../../icemedx-lib/src/models/ehr/subs/managementguideline';
import { managementguidelineindex } from '../../../../icemedx-lib/src/models/ehr/subs/managementguidelineindex';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { reportdata } from '../../../../icemedx-lib/src/models/reports/reportdata';
import { alert } from '../../../../icemedx-lib/src/models/system/alert';
import { patientstat } from '../../../../icemedx-lib/src/models/stats/patientstat';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { OrderService } from '../../../../icemedx-lib/src/services/orders/order.service';
import { PatientService } from '../../../../icemedx-lib/src/services/patient/patient.service';
import { AppService } from '../app.service';
import { coderesult } from '../../../../icemedx-lib/src/services/cds/guidelinesummary';
import { basecode } from '../../../../icemedx-lib/src/models/ehr/subs/basecode';
import { DrugComposition, DrugIngredient, DrugIngredientsResponse, DrugSideEffect, DrugsSideEffectsResponse } from '../../../../icemedx-lib/src/models/ehr/subs/drugresponse';
import { diagnosisreference } from '../../../../icemedx-lib/src/models/ehr/subs/diagnosisreference';
import { medicalservicereference } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservicereference';

var thisComponent = null;

@Component({
  selector: 'icemanagementguidelinesummary',
  templateUrl: './managementguidelinesummary.component.html',
  styleUrls: ['./managementguidelinesummary.component.scss'],
  providers: [AppService, IceNavService, IcepanelComponent, IcepanelContainerComponent]
})
export class ManagementguidelinesummaryComponent implements OnInit {

  // Data
  cpoeOrders: orderentryindex[] = null;
  cglList: managementguidelineindex[] = [];
  glReportData: reportdata = null;
  otherCGLList: any = {};

  @Input() trans_account: string = "";
  @Input() trans_account_name: string = "";
  @Input() account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  @Input() currentCGL: number = 0;
  @Input() chargeList: medicalservice[] = [];
  @Input() chargeRefs: medicalservicereference[] = [];
  @Input() diagRefs: diagnosisreference[] = [];

  @Output() onContinueClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() onBackClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDoneClick: EventEmitter<any> = new EventEmitter<any>();

  // CGL
  cglBackButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "75px", text: "Back", glyphClass: "fa-arrow-left" }, null, null, "backButton");
  cglContinueButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "75px", text: "Continue", glyphClass: "fa-file-alt" }, null, null, "continueButton");
  cglDoneButtonCtrl: IcecontrolSettings = new IcecontrolSettings("icebutton", { width: "50px", text: "Done" }, null, null, "doneButton");

  cglOrderedMedicationCtrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "100%" }, null, null, "OrderedMedication", "Ordered Medication")
    .setControlName("OrderedMedication")
    .createFormControl(0, [Validators.required]);
  cglOrderedDateCtrl: IcecontrolSettings = new IcecontrolSettings("icelabel", { width: "100%", value: "Ordered Date: " }, null, {}, "OrderedDate")
    .setControlName("OrderedDate")
    .createFormControl("", []);
  cglOrderedCodeCtrl: IcecontrolSettings = new IcecontrolSettings("icelabel", { width: "100%", value: "Ordered Code: " }, null, {}, "OrderedCode")
    .setControlName("OrderedCode")
    .createFormControl("", []);
  cglOrderStatusCtrl: IcecontrolSettings = new IcecontrolSettings("icelabel", { width: "100%", value: "Order Status: " }, null, {}, "OrderStatus")
    .setControlName("OrderStatus")
    .createFormControl("", []);
  cglOrderingDoctorCtrl: IcecontrolSettings = new IcecontrolSettings("icelabel", { width: "100%", value: "Ordering Doctor: " }, null, {}, "OrderingDoctor")
    .setControlName("OrderingDoctor")
    .createFormControl("", []);

  cglExclude: any = {};
  cglExcludeReason: any = {};

  constructor(private appSvc: AppService,
    private loginSvc: LoginService,
    private navSvc: IceNavService,
    private domainSvc: DomainService,
    private ptSvc: PatientService,
    private acctSvc: AccountingService,
    private medCodeSvc: MedicalcodesService,
    private ordSvc: OrderService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {
    thisComponent = this;
  }

  ngOnInit() {
    if (this.glReportData == null) {
      this.ptSvc.getCDSResults(this.trans_account, this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), "", "", "", 0, "", "", "", "").subscribe(
        data => {
          if (data == null || data.length == 0) return;

          for (let idat = 0; idat < data.length; idat++) {
            let thisobj = data[idat];
            if (false == Iceutility.isfunction(thisobj.gettablename)) continue;

            if (thisobj.gettablename() == "MANAGEMENT_GUIDELINE_INDEX") {
              let glidx = <managementguidelineindex>thisobj;
              if (this.cglList == null)
                this.cglList = [];

              this.cglList.push(glidx);
            }
            else if (thisobj.gettablename() == "REPORT_DATA") {
              this.glReportData = <reportdata>thisobj;
            }
          }          
        },
        error => {
        });
    }
    if (thisComponent != null)
      thisComponent.loadInformation();
  }

  getCGLSourceType(charge: medicalservice): string {
    if (charge == null) return "";

    if (charge.product_service_id_qualifier == "NDC")
      return "Medication to Dispense";

    return "Service/Product";
  }

  getMatchingGLs(charge: medicalservice): managementguideline[] {
    let ret: managementguideline[] = [];
    for (let igl = 0; igl < this.cglList.length; igl++) {
      let gl = this.cglList[igl];
      if (gl == null) continue;

      if (gl.administered_code == charge.code) {
        ret.push(gl);
      }
    }
    return ret;
  }

  getListofAlerts(charge: medicalservice): alert[] {
    if (this.glReportData == null) return [];
    let res: alert[] = charge.ALERTS;
    let foundPt = this.glReportData.PATIENTSTATS.filter(pt => pt.trans_account == this.trans_account);
    if (foundPt.length > 0) {
      let ptstat: patientstat = foundPt[0];
      let foundCodeMatch = [];

      // find charge code alerts
      let foundCode = ptstat.CDSRESULTSBYKEY.filter(r => r["code"] == charge.code);
      if (foundCode.length > 0)
        foundCodeMatch = foundCodeMatch.concat(foundCode);

      // find charge pointer code alerts
      let fngChargeRefs = this.chargeRefs.filter(chg => chg.medical_service_key == charge.medical_service_key);
      if (fngChargeRefs.length > 0) {
        for (let iDxRef = 0; iDxRef < fngChargeRefs[0].DIAGREFS.length; iDxRef++) {
          let dxRef = fngChargeRefs[0].DIAGREFS[iDxRef];
          foundCode = ptstat.CDSRESULTSBYKEY.filter(r => r["code"] == dxRef.icd_code);
          if (foundCode.length > 0)
            foundCodeMatch = foundCodeMatch.concat(foundCode);        }
      }

      for (let i = 0; i < foundCodeMatch.length; i++) {
        let foundAlert = res.filter(a => a.alert_key == foundCodeMatch[i].reportkey);
        if (foundAlert.length > 0) continue;

        if (foundCodeMatch[i].gettablename() == "CodeResult") {
          let codeRes: coderesult = <coderesult>foundCodeMatch[i];
          let alt = new alert();
          alt.alert_key = codeRes.reportkey; // To first check to see if exists in charge.ALERTS then add
          alt.alert_date = Iceutility.GetDateText(Iceutility.GetLocalDate(), null, true);
          alt.title = codeRes.title;
          let secondType = [];
          let fndGL = this.cglList.filter(g => g.management_guideline_key == codeRes.glkey);
          if (fndGL.length > 0) {
            let fndProc = fndGL[0].PROCSRS.filter(p => p.procedure_key == codeRes.with_key);
            if (fndProc.length > 0) {
              if (Iceutility.toBoolean(fndProc[0].consider) == true)
                secondType.push("Consider: ");
            }
          }

          alt.description = secondType.join(" ") + codeRes.code + " (" + codeRes.title + ") " + " with " + codeRes.with_code + " (" + codeRes.with_title + ")";
          alt.alert_type = Iceutility.toLong(codeRes.alert_type);
          alt.severity_type = IceTypes.severitytype.servTypeCritical; // To do: this should come from codeRes
          alt.management_guideline_key = codeRes.glkey;
          res.push(alt);
          this.chargeList[this.currentCGL].offline_record_status = IceTypes.offlineRecStatus.offlineUpdate;
        }
        else if (foundCodeMatch[i].gettablename() == "LimitAndSurveyResult") {
          // To do
        }
      }
    }
    return res;
  }


  // To do this function should return alerts like getListofAlerts
  getOtherListofAlerts(charge: medicalservice): alert[] {
    if (this.glReportData == null) return [];

    let res: alert[] = charge.ALERTS;
    if (this.otherCGLList[charge.code] != null) {
      let cglCodes = <basecode[]>this.otherCGLList[charge.code];
      if (cglCodes != null && cglCodes.length > 0) {
        for (let ibc = 0; ibc < cglCodes.length; ibc++) {
          let bc = cglCodes[ibc];

          if (this.cglExclude[bc.key] == null) {
            this.cglExclude[bc.key] = new IcecontrolSettings("icecheckbox", { width: "100%", cursor: 'pointer', label: "Include" }, null, null, "Exclude" + bc.key, "Test")
              .setControlName("Exclude" + bc.key)
              .createFormControl(false, [Validators.required])
          }

          if (this.cglExcludeReason[bc.key] == null) {
            this.cglExcludeReason[bc.key] = new IcecontrolSettings("icetextarea", { width: "100%" }, null, null, "ExcludeReason" + bc.key, "Reason for Excluding " + bc.title)
              .setControlName("ExcludeReason" + bc.key)
              .createFormControl("", []);
          }

          let foundAlert = charge.ALERTS.filter(a => a.alert_key == bc.key);
          if (foundAlert.length > 0) continue;
          let newalt = this.getOtherAlert(bc);

          if (this.cglExclude[newalt.alert_key] != null) {
            let ctrl: IcecontrolSettings = this.cglExclude[newalt.alert_key];
            ctrl.properties.label = newalt.title + " " + MedicalcodesService.getAlertType(<IceTypes.ALERTTYPE>Iceutility.toLong(newalt.alert_type))
          }

          res.push(newalt);
        }
      }
    }

    return res;
  }

  getOtherAlert(basealt: basecode): alert {
    if (basealt == null) return null;

    let ret = new alert();
    ret.alert_key = basealt.key;
    ret.alert_date = Iceutility.ConvertToUTC(Iceutility.GetLocalDate(), true);
    ret.alert_type = IceTypes.ALERTTYPE.alertNotification;
    ret.title = basealt.title;

    let desc: string[] = [];
    if (basealt.description.length > 0)
      desc.push(basealt.description);

    if (basealt["DITXML"] != null) {
      var drgres = basealt["DITXML"][0];
      if (drgres != null && Iceutility.isfunction(drgres.gettablename) && drgres.gettablename() == new DrugsSideEffectsResponse().gettablename()) {
        var drglist = drgres["SideEffectList"];
        if (drglist != null) {
          for (let idrg = 0; idrg < drglist.length; idrg++) {
            let drg: DrugSideEffect = drglist[idrg];
            if (drg != null) {
              desc.push(drg.effect + "(" + drg.relevance + ")");
            }
          }
        }
      }
      else if (drgres != null && Iceutility.isfunction(drgres.gettablename) && drgres.gettablename() == new DrugIngredientsResponse().gettablename()) {
        let ingredient = basealt.gettablename() == "INGREDIENT";
        var drglist = drgres[ingredient ? "IngredientList" : "CompositionList"];
        if (drglist != null) {
          for (let idrg = 0; idrg < drglist.length; idrg++) {
            if (!ingredient) {
              let drg: DrugComposition = drglist[idrg];
              if (drg != null) {
                desc.push(drg.ingname);
                desc.push(" Form: " + drg.form);
                desc.push(" Class: " + drg.ingclass);
                desc.push(" Qty.: " + drg.quantity.toString() + "\n");
              }
            }
            else {
              let drg: DrugIngredient= drglist[idrg];
              if (drg != null) {
                desc.push(drg.ingname);
              }
            }
          }
        }
      }
      //else if (drgres != null && Iceutility.isfunction(drgres.gettablename) && drgres.gettablename() == new DrugIngredientsResponse().gettablename()) {
      //  var drglist = drgres["IngredientList"];
      //  if (drglist != null) {
      //    for (let idrg = 0; idrg < drglist.length; idrg++) {
      //      let drg: DrugIngredient = drglist[idrg];
      //      if (drg != null) {
      //        desc.push(drg.ingname);
      //      }
      //    }
      //  }
      //}

    }
    ret.description = desc.join(",");
    return ret;
  }

  getImportance(alt: alert): string {
    let ret = "";
    ret = MedicalcodesService.getAlertType(<IceTypes.ALERTTYPE>Iceutility.toLong(alt.alert_type));
    ///*To do this should be used once all of the severity are included and tide to the GL results*/  + " (Severity: " + MedicalcodesService.getSeverityType(<IceTypes.severitytype>Iceutility.toLong(alt.severity_type)) + ")";
    return ret;
  }

  onOrderedMedication(event): void {
    let foundOpt = this.cglOrderedMedicationCtrl.getOptions().filter(opt => opt.value == event.value);
    if (foundOpt.length > 0) {
      this.cglOrderedDateCtrl.getFormControl().setValue(Iceutility.getDateTextEx(Iceutility.GetLocalDate(foundOpt[0].order_entry_date)));
      this.cglOrderedCodeCtrl.getFormControl().setValue(foundOpt[0].code);
      this.cglOrderStatusCtrl.getFormControl().setValue(OrderService.getStatus(Iceutility.toLong(foundOpt[0].order_status_type)));
      this.cglOrderingDoctorCtrl.getFormControl().setValue(foundOpt[0].provider_name);
    }
  }

  lookupNDCInformation(code: string): void {
      this.medCodeSvc.getCodes("NDCCODE_INFORMATION", "", code, "").subscribe(
        data => {
          if (data && data.length > 0 && data[0] != null) {
            if (this.otherCGLList[code] == null || this.otherCGLList[code].length == 0)
              this.otherCGLList[code] = data;
          }
        },
        error => {
          console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
        });
  }

  loadInformation(): void {
    if (this.chargeList[this.currentCGL].product_service_id_qualifier == "NDC" /*|| CPT*/) {
      // loadCLGOrderDetails()
      let actType = this.appSvc.getCurrentAccountType();
      let useAPI = actType == IceTypes.ACCOUNT_TYPE.actProvider || actType == IceTypes.ACCOUNT_TYPE.actFacility ? "providers" : "pharmacies";
      this.ordSvc.getOrders(useAPI, this.appSvc.getCurrentAccount(), "", "", "", "", 0, 250, "", false, this.trans_account).subscribe(
        data => {
          if (data != null) {
            let cpoes: orderentryindex[] = data;
            this.cpoeOrders = cpoes;

            // intializeCGLOrderDetails();
            let foundCPOE = cpoes.filter(o => o.order_status_type == IceTypes.orderentrystatus.oestatusTransactionPending || o.order_status_type == IceTypes.orderentrystatus.oestatusTransactionAccepted);
            if (foundCPOE.length > 0) {
              let opts = foundCPOE.map(o => {
                return {
                  value: o.order_entry_key, name: o.order_information + " ordered: " + Iceutility.getDateTextEx(Iceutility.GetLocalDate(o.order_entry_date)),
                  order_entry_date: o.order_entry_date,
                  order_status_type: o.order_status_type,
                  provider_name: o.provider_name,
                  code: o.code
                }
              });
              opts.sort(function (a, b) {
                return new Date(b.order_entry_date).getTime() - new Date(a.order_entry_date).getTime()
              });
              this.cglOrderedMedicationCtrl.setOptions(this.cglOrderedMedicationCtrl.getOptions().concat(opts));
              this.cglOrderedMedicationCtrl.getFormControl().setValue(opts[0].value);
              this.cglOrderedDateCtrl.getFormControl().setValue(Iceutility.getDateTextEx(Iceutility.GetLocalDate(opts[0].order_entry_date)));
              this.cglOrderedCodeCtrl.getFormControl().setValue(opts[0].code);
              this.cglOrderStatusCtrl.getFormControl().setValue(OrderService.getStatus(Iceutility.toLong(opts[0].order_status_type)));
              this.cglOrderingDoctorCtrl.getFormControl().setValue(opts[0].provider_name);
            }
          }
        },
        error => {
          console.log(error);
        });

      this.lookupNDCInformation(this.chargeList[this.currentCGL].code);
    }
  }

  continueClick(event): void {
    // Update CGLs

    if (this.currentCGL < this.chargeList.length - 1) {
      this.currentCGL++;

      this.cglOrderedMedicationCtrl.setOptions([]);
      this.cglOrderedMedicationCtrl.getFormControl().setValue("");
      this.cglOrderedDateCtrl.getFormControl().setValue("");
      this.cglOrderedCodeCtrl.getFormControl().setValue("");
      this.cglOrderStatusCtrl.getFormControl().setValue("");
      this.cglOrderingDoctorCtrl.getFormControl().setValue("");
      this.loadInformation();
    }
    else {
      // emit
      this.onContinueClick.emit();
    }
  }

  backClick(event): void {
    // Update CGLs
    if (this.currentCGL == 0) {
      this.onBackClick.emit();
    }
    else {
      this.currentCGL--;
    }
  }

  doneClick(event): void {
    debugger;
    this.onDoneClick.emit();
  }
}
